<template>
    <div class="list-container">
        <div class="container" v-for="(item, index) in list" :key="index">
            <b-button variant="primary" class="w-100 button" @click="select(item)" :disabled="JSON.stringify(item) == JSON.stringify(value)">
                <div class="titles">
                    <h5 class="title">{{item.title}}</h5>
                    <small class="subtitle">{{ item.subtitle }}</small>
                </div>
                <div v-if="item?.help?.text?.length > 0" class="help-container" @click.stop="$bvModal.show('help-modal-' + index)">
                    <font-awesome-icon icon="question-circle" class="help-icon" aria-hidden="true"></font-awesome-icon>
                </div>
            </b-button>
            <b-modal :id="'help-modal-' + index" v-if="item?.help?.text?.length > 0" centered hide-footer>
                <template #modal-title>
                    {{ item.help.title }}
                </template>
                <div class="d-block text-center">
                    <p>{{ item.help.text }}</p>
                </div>
            </b-modal>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import { BButton, BModal, ModalPlugin } from "bootstrap-vue";

import { library } from "@fortawesome/fontawesome-svg-core";
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(faQuestionCircle);

Vue.use(ModalPlugin);

export default {
    props: ["list", "value"],
    emits: ["selected", "update:modelValue"],
    components: {
        "font-awesome-icon": FontAwesomeIcon,
        BButton,
        BModal,
    },
    data: function () {
        return {
            
        };
    },
    computed: {
        model: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit("input", value);
            }
        }
    },
    methods: {
        select(item) {
            this.model = item;
            this.$emit("selected", structuredClone(item));
        }
    },
};
</script>

<style scoped lang="scss">
.list-container {
    display: grid;
    overflow: visible;
    grid-auto-rows: 1fr;
    row-gap: 6px;
    max-width: 100%;

    .container {
        flex: 1 0 100%;
    }
    .button {
        position: relative;
        display: flex;
        height: 100%;
        border-radius: 8px;
    }
}

.titles {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    @for $index from 1 through 6 {
        h#{$index}{
            margin-bottom: 0;
        }
    }

    .title {
        margin-bottom: 2px;
    }

    .subtitle {
        display: block;
    }
}

.help-container {
    right: 0;
    width: 13%;
    flex-basis: 13%;
    flex-shrink: 0;
    margin: -6px -12px -6px 0;
    height: calc(100% + 12px);
    display: flex;
    align-items: center;
    justify-content: center;

    .help-icon {
        transform: scale(1.3);
    }
}

</style>
